import { VIDEOS_API_URL } from "../constants/api";
class VideoService {
  async getVideos() {
    try {
      const response = await fetch(`${VIDEOS_API_URL}Videos`, {
        method: "GET",
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        throw new Error(`Error loading videos (status ${response.status})`);
      }

      return await response.json();
    } catch (e) {
      throw new Error(e?.message || "Error loading videos");
    }
  }
}

export default new VideoService();